var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('full-screen',{staticClass:"rtl",attrs:{"max-width":"1200px"}},[_c('v-container',{staticStyle:{"height":"100%"}},[_c('v-row',{staticStyle:{"height":"100%"},attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"60"}})],1)],1)],1)],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }